import * as fromDatatype from "../datatype-library/index";

export interface bl_pos_sales_lead_label_hdr_RowInterface
{
	guid: fromDatatype.GuidDataFieldInterface;
	name: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.TextDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_pos_sales_lead_label_hdr_RowClass implements bl_pos_sales_lead_label_hdr_RowInterface
{
	guid: fromDatatype.GuidDataFieldInterface;
	name: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.TextDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}
